import { useState } from "react";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import useProfileDetails from "../hooks/useProfileDetails";
import { EditNameDialog } from "./dialogs/EditNameDialog";
import { DisplayData } from "./DisplayData";
import { DisplayDataEdit } from "./DisplayDataEdit";
import { DisplayDataTitle } from "./DisplayDataTitle";

function DetailsInformation() {
  const t = useTranslate("Profile");
  const profile = useProfileDetails();
  const [showDialog, setShowDialog] = useState(false);

  return (
    <section className="card">
      <header>
        <h3>{t("title")}</h3>
        <p>{t("description")}</p>
        <hr />
      </header>
      <DisplayDataEdit
        title={t("nameLabel")}
        description={profile.name}
        onEdit={() => setShowDialog(true)}
      />

      <DisplayData>
        <DisplayDataTitle title={t("emailLabel")} description={profile.email} />
      </DisplayData>

      {showDialog && (
        <EditNameDialog
          fname={profile.firstName}
          lname={profile.lastName}
          onClose={() => {
            setShowDialog(false);
          }}
        />
      )}
    </section>
  );
}

export function Details() {
  const t = useTranslate("Details");

  return (
    <section className="details" id="details">
      <header>
        <h2>{t("title")}</h2>
        <p>{t("description")}</p>
        <hr />
      </header>

      <DetailsInformation />
    </section>
  );
}
